import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import Papa from 'papaparse';

export const generateAuditPackage = async (tenantId: string): Promise<Record<string, string>> => {
  const collections = ['cash_tips', 'disputes', 'master_transactions', 'shifts', 'staff'];
  const auditData: Record<string, string> = {};

  for (const colName of collections) {
    const colRef = collection(db, 'tenants', tenantId, colName);
    const snapshot = await getDocs(colRef);
    const data = snapshot.docs.map(doc => doc.data());
    
    if (data.length > 0) {
      auditData[colName] = Papa.unparse(data);
    }
  }

  return auditData;
};
